import React from 'react';
import { useAuth } from '@/context/AuthContext';
import { Navigate, useLocation } from 'react-router-dom';
import { FullPageLoader } from '@/components/Loaders';

export function RequireAuth({ children, role }) {
  const { user, loading } = useAuth();
  const loc = useLocation();
  if (loading) return <FullPageLoader />;
  if (!user) return <Navigate to="/auth/login" replace state={{ from: loc.pathname }} />;
  if (role && user.role !== role && !(role === 'venue_owner_or_admin' && (user.role === 'venue_owner' || user.role === 'admin'))) {
    return <Navigate to="/" replace />;
  }
  return children;
}
